export default "20260402.1 \r\n"